import React, { useEffect, useState } from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";
import { api_url } from "../../constant/constant";
import AddLesson from "../../Components/AddLessonModal/AddLesson";
// import EditLesson from '../../Components/EditLessonModal/EditLesson';
import { useNavigate } from "react-router-dom";
import "./Lessons.css";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "react-bootstrap";
import { showToast } from "../../Components/ShowToast/ToastNotification";
import { NavLink } from "react-router-dom";

const Lessons = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [data, setLessons] = useState([]);
  const [links, setLinks] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedLessonId, setSelectedLessonId] = useState(null);

  const handleDelete = async (id) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("userToken");
      const response = await fetch(`${api_url}/leales/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        fetchLessons("");
        showToast(t("lessondeletesuccess"), "success");
        setShowModal(false);
      } else {
        showToast(t("lessondeletefailed"), "error");
        setShowModal(false);
      }
    } catch (error) {
      setShowModal(false);
      showToast(t("lessondeleteerror"), "error");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (searchVal !== "") {
      const filteredData = data.filter(
        (item) =>
          item.title_en.toLowerCase().includes(searchVal.toLowerCase()) ||
          item.title_ar.toLowerCase().includes(searchVal.toLowerCase()) ||
          item.code.toLowerCase().includes(searchVal.toLowerCase()) ||
          item.lesson_type_name.toLowerCase().includes(searchVal.toLowerCase())
      );
      setLessons(filteredData);
    } else {
      fetchLessons("");
    }
  }, [searchVal]);

  const fetchLessons = async (url = "") => {
    setLoading(true);

    try {
      const token = localStorage.getItem("userToken");
      const response = await fetch(url || `${api_url}/leales`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      setLessons(result.data.data);
      setLinks(result.data.links);
    } catch (error) {
      showToast(t("lessonfetcherror"), "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLessons("");
  }, []);

  const columns = React.useMemo(
    () => [
      {
        accessorKey: "title_en",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i class="bi bi-card-text"></i>
            {t("Title(English)")}
          </div>
        ),
        colName: t("Title(English)"),
      },
      {
        accessorKey: "title_ar",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i class="bi bi-card-text"></i>
            {t("Title(Arabic)")}
          </div>
        ),
        colName: t("Title(Arabic)"),
      },
      {
        accessorKey: "code",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i class="bi bi-code-slash"></i>
            {t("Code")}
          </div>
        ),
        colName: t("Code"),
      },
      {
        accessorKey: "lesson_type_name",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i class="bi bi-person-badge"></i>
            {t("LessonType")}
          </div>
        ),
        colName: t("LessonType"),
      },
      {
        accessorKey: "id",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <img src="/images/fi_alert-octagon.png" alt="Source" />
            {t("Action")}
          </div>
        ),
        cell: ({ getValue }) => {
          const id = getValue();
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {/* <EditLesson id={id} parentfetchLessons={fetchLessons} /> */}
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <div
                  className="iconDel"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedLessonId(id);
                    setShowModal(true);
                  }}
                >
                  <img src="/images/fi_trash-2.png" alt="Delete" />
                  {t("Delete")}
                </div>
              </div>
            </div>
          );
        },
        colName: t("Action"),
      },
    ],
    []
  );

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  const handleLessonRowClick = (id) => {
    navigate(`/lessons/${id}/detail`);
  };

  return (
    <div className="p-4 mb-4">
      <div className="pageTitle mb-4">{t("AllLessons")}</div>
      <div className="primaryBlueBox p-5 mb-4">
        <div className="row">
          <div className="col-md-4">
            <label className="form-label">{t("SearchLesson")}</label>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder={t("Searchbytitle")}
                value={searchVal}
                onChange={(e) => setSearchVal(e.target.value)}
              />
              <button
                className="btn btn-outline-secondary btnSearchIcon"
                type="button"
              >
                <i className="bi bi-search"></i>
              </button>
            </div>
          </div>
          <div className="col-md-1">
            <div className="vrLine"></div>
          </div>
          <div className="col-md-7">
            {/* <AddLesson parentfetchLessons={fetchLessons} /> */}
            <NavLink className="btnWhiteGradient mt-4" to="/Add-Lesson">
              <i class="bi bi-envelope me-2 mt-3 h6"></i> {t("AddLesson")}
            </NavLink>
          </div>
        </div>
      </div>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center my-5">
          <div
            className="spinner-border"
            role="status"
            style={{
              borderTopColor: "#6897CB",
              borderBottomColor: "#6897CB",
              borderLeftColor: "#6897CB",
              marginTop: "50px",
            }}
          ></div>
        </div>
      ) : (
        <div className="bg-light px-3 py-3 lessonsTableWrapper resTable overflow-auto">
          {window.innerWidth < 768 ? (
            table.getRowModel().rows.map((row) => (
              <div
                key={row.id}
                className="stacked-row"
                onClick={
                  row.id.includes("id") === false
                    ? () => handleLessonRowClick(row.original.id)
                    : null
                }
              >
                {row.getVisibleCells().map((cell) => (
                  <div key={cell.id} className="stacked-cell">
                    <strong className="me-1">
                      {cell.column.columnDef.colName}:
                    </strong>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </div>
                ))}
              </div>
            ))
          ) : (
            <table className="table table-bordered table-hover">
              <thead>
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                      <th key={header.id}>
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody>
                {table.getRowModel().rows.map((row) => (
                  <tr key={row.id}>
                    {row.getVisibleCells().map((cell) => (
                      <td
                        key={cell.id}
                        className="rowAnchor"
                        onClick={
                          cell.id.includes("id") === false
                            ? () => handleLessonRowClick(row.original.id)
                            : null
                        }
                      >
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      <div className="navigationWrapper">
        <ul>
          {links.map((link, index) => (
            <li
              key={index}
              className={`${link.active ? "active" : ""} ${
                link.url === null ? "disabled" : ""
              }`}
              onClick={
                link.url !== null ? () => fetchLessons(link.url) : undefined
              }
            >
              <div dangerouslySetInnerHTML={{ __html: link.label }} />
            </li>
          ))}
        </ul>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("ConfirmDelete")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("Areyousureyouwanttodeletethislesson?")}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            {t("Cancel")}
          </Button>
          <Button
            variant="danger"
            onClick={() => handleDelete(selectedLessonId)}
            disabled={loading}
          >
            {loading ? t("Deleting...") : t("Delete")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Lessons;
